import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, ExternalLink } from "lucide-react";

const ACTIVITY_LABELS = {
  family: "Family",
  free: "Free",
  outdoor: "Outdoor",
  action: "Action",
  ocean: "Ocean",
  tour: "Tour",
  scenic: "Scenic",
  eco: "Eco / conservation",
  other: "Other",
  // Legacy slugs from earlier submissions — keep so existing tours still label correctly.
  sail: "Ocean",
  sunset_sail: "Ocean",
  reef: "Ocean",
  whitehaven: "Ocean",
  skydive: "Action",
  explore: "Tour",
};

export default function TourCard({ tour, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.45, delay: Math.min(index * 0.05, 0.4) }}
      className="card-hover"
    >
      <Link
        to={`/tour/${tour.id}`}
        className="block rounded-2xl overflow-hidden bg-white border border-black/5 h-full"
        data-testid={`tour-card-${tour.id}`}
      >
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={tour.image}
            alt={tour.title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            loading="lazy"
          />
          <div className="absolute top-3 left-3 bg-white/95 backdrop-blur px-3 py-1 rounded-full text-xs text-navy font-medium">
            {ACTIVITY_LABELS[tour.activity_type] || tour.activity_type}
          </div>
        </div>
        <div className="p-5">
          <h3 className="font-heading text-lg text-navy mb-2 line-clamp-2">{tour.title}</h3>
          <p className="text-sm text-neutral-500 line-clamp-2 mb-4 leading-relaxed">{tour.description}</p>
          <div className="flex items-center justify-between text-xs text-neutral-500">
            <span className="flex items-center gap-1.5">
              <Clock className="w-3.5 h-3.5" /> {tour.duration_label}
            </span>
            <span className="font-medium text-navy text-base">
              From ${Math.round(tour.price_from)}
              <span className="text-[10px] text-neutral-400 ml-1">{tour.currency}</span>
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
